import { render, staticRenderFns } from "./leaveAddorUpdate.vue?vue&type=template&id=2800a052&"
import script from "./leaveAddorUpdate.vue?vue&type=script&lang=js&"
export * from "./leaveAddorUpdate.vue?vue&type=script&lang=js&"
import style0 from "./leaveAddorUpdate.vue?vue&type=style&index=0&id=2800a052&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports